import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { CurrencyCode } from 'features/globalSetup/types/currency'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

export const useGetCurrencyCodesOptions = (): {
  currencyCodesOptions: SelectOption<CurrencyCode>[]
} => {
  const [result, setResult] = useState<SelectOption<CurrencyCode>[]>([])

  type Data = {
    currencyEnum: {
      value: CurrencyCode
    }[]
  }

  useQuery<never, Data>({
    onCompleted: async data => {
      if (data !== undefined) {
        setResult(
          data.currencyEnum.map(
            (el: { value: CurrencyCode }): SelectOption<CurrencyCode> => ({
              label: el.value,
              value: el.value,
            }),
          ),
        )
      }
    },
    query: gql`
      query getCurrencyCodes {
        currencyEnum {
          value
        }
      }
    `,
  })

  return {
    currencyCodesOptions: result,
  }
}
